module.exports = __webpack_public_path__ + "img/client-logo4.67a7d0bc.png";